import { Outlet } from 'react-router';

/** Page frame: max width (grown with the content scale on big screens), gutters, full-height column. Screens render inside. */
export function Shell() {
  return (
    <div className="mx-auto flex min-h-full max-w-[calc(1440px*var(--stage))] flex-col px-[clamp(16px,4vw,48px)] pt-8 pb-12">
      <Outlet />
    </div>
  );
}
